import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@app/environment/environment';
import { SetInvestorQualificationRequest } from '@app/models/account.model';
import { LegalEntity } from '@app/models/project.models';
import { ApprovalRepresentationTypes } from '@app/models/shared.enums';
import { PaginatedData } from '@app/models/shared.models';
import { Observable } from 'rxjs';
import { FileData } from '../file/upload.service';

export interface ApprovalRequest {
  userId: string;
  files: FileData[];
  represents: ApprovalRepresentationTypes;
}

@Injectable({
  providedIn: 'root',
})
export class LegalPersonService {
  private readonly API_URL = environment.apiUrl;
  private http = inject(HttpClient);

  getLegalEntities(taxNumber: string): Observable<PaginatedData<LegalEntity>> {
    return this.http.get<PaginatedData<LegalEntity>>(
      `${this.API_URL}/LegalEntities/${taxNumber}`,
    );
  }

  createLegalEntity(legalEntity: Partial<LegalEntity>) {
    return this.http.post<LegalEntity>(
      `${this.API_URL}/LegalEntity/CreateIfNotExists`,
      legalEntity,
    );
  }

  postApprovalRequest(legalEntityId: string, request: ApprovalRequest) {
    const formData = new FormData();
    formData.append('UserId', request.userId);
    formData.append('UserRepresentation', String(request.represents));

    request.files.forEach((file) => {
      formData.append('UploadedFiles', file.uploadedFile);
      formData.append(
        'UploadedFilesDescriptions',
        file.uploadedFileDescription,
      );
      formData.append('UploadedFilesTypes', String(file.uploadedFileType));
    });

    const url = `${this.API_URL}/LegalEntity/${legalEntityId}/ApprovalRequest`;
    return this.http.post<any>(url, formData);
  }

  setInvestorsQualification(
    legalEntityId: string,
    qualificationRequest: SetInvestorQualificationRequest,
  ) {
    return this.http.post<LegalEntity>(
      `${this.API_URL}/api/LegalEntity/${legalEntityId}/SetInvestorQualification`,
      qualificationRequest,
    );
  }
}
